export default "__VITE_PUBLIC_ASSET__3adb6af1__"